<template>
  <div id="contract_center">
    <div class="contract-title">
      <div class="title-left">
        <img src="@/assets/image/PersonalCenter/ContractCenter/contract_title.png">
        合同信息
      </div>
      <div class="title-right">
         {{text}}
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import {apigetcontractset} from "@/request/API";

export default {
  name: 'ContractCenter',
  props: {},
  components: {},
  data () {
    return {
      text: ''
    }
  },
  created() {
    apigetcontractset().then(res => {
      this.text = res.data.contract_copy_descript
    })
  },
  methods: {},
  mounted () {},
  watch: {},
  computed: {}
}
</script>
<style lang='less' scoped>
#contract_center{
  display: flex;
  flex-direction: column;
  min-height: max(680px, calc(100vh - 430px));
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .contract-title{
    height: 72px;
    background: var(--bg-dark, #1A1D24);
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    color: #fff;
    font-size: 19px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 600;
    border-radius: 4px 4px 0 0;
    box-shadow: 0 6px 14px rgba(26, 29, 36, 0.1);
    img{
      width: 38px;
      height: 38px;
      margin-right: 12px;
      padding: 8px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.18);
      object-fit: contain;
    }
    .title-left{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      min-width: 0;
      line-height: 26px;
    }
    .title-right{
      max-width: 520px;
      font-size: 13px;
      line-height: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.78);
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .tabbar{
    margin-top: 22px;
    height: 58px;
    background: #F4F4F4;
    border-radius: 4px;
    padding: 0 71px;
    display: flex;
    flex-direction: row;
    align-items: center;
    div{
      font-size: 16px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 300;
      color: #5B5B5B;
      margin-right: 83px;
      cursor: pointer;
    }
    .isAcitve{
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #5B5B5B;
      padding-bottom: 6px;
      background: url("../../../assets/image/PersonalCenter/MyCollection/selectItem.png") no-repeat;
      background-position:bottom;
    }
    div:last-of-type{
      margin: 0;
    }
  }
}
</style>
